import { Link } from 'react-router-dom';

function PricingBox({ title, price, features, onClick, buttonText, buttonLink, buttonClass = 'bg-blue-600 hover:bg-blue-700 text-white' }) {
    return (
      <div className="bg-white p-8 rounded-lg shadow-lg flex-1">
        <h3 className="text-2xl font-bold mb-4">{title}</h3>
        <p className="text-3xl font-semibold mb-6">{price}</p>
        <ul className="space-y-2 mb-6">
          {features.map((feature, index) => (
            <li key={index} className="flex items-center gap-2">
              <span className="text-green-500">✓</span> {feature}
            </li>
          ))}
        </ul>
        {buttonLink ? (
          <Link to={buttonLink} className={`block text-center w-full p-3 rounded transition duration-200 ${buttonClass}`}>
            {buttonText}
          </Link>
        ) : (
          <button onClick={onClick} className={`w-full p-3 rounded transition duration-200 ${buttonClass}`}>
            {buttonText}
          </button>
        )}
      </div>
    );
  }
  
  export default PricingBox;
